<template>
  <div>
    <a-spin :spinning="loading">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">
            <strong>Add details</strong>
          </h5>

          <a-row>
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
              <a-form-model ref="ruleForm" :model="form" :rules="rules">
                <a-form-model-item
                  ref="name"
                  prop="name"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Name"
                  @blur="
                    () => {
                      $refs.name.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.name" />
                </a-form-model-item>
                <a-form-model-item
                  ref="reportEmails"
                  prop="reportEmails"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Report emails"
                  help="Delimit with ';'"
                  @blur="
                    () => {
                      $refs.reportEmails.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.reportEmails" />
                </a-form-model-item>

                <a-form-model-item
                  ref="shortName"
                  prop="shortName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Short name"
                  @blur="
                    () => {
                      $refs.shortName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.shortName" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Phone"
                >
                  <a-input v-model="form.phone" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Address line 1"
                >
                  <a-input v-model="form.addressLine1" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Address line 2"
                >
                  <a-input v-model="form.addressLine2" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="ZIP code"
                >
                  <a-input v-model="form.zipCode" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="City"
                >
                  <a-input v-model="form.city" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Country"
                >
                  <a-input v-model="form.country" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="VAT code"
                >
                  <a-input v-model="form.vatCode" />
                </a-form-model-item>

                <a-form-model-item
                  ref="collateral"
                  prop="collateral"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Collateral"
                >
                  <a-input-number
                    v-model="form.collateral"
                    style="width: 200px;"
                  />
                  EUR
                </a-form-model-item>
                <h5 class="mb-4">
                  <strong>Assign users</strong>
                </h5>
                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Users"
                >
                  <a-select
                    mode="multiple"
                    show-search
                    option-filter-prop="children"
                    allowClear
                    style="width: 100%;"
                    placeholder="Select users to assign"
                    :filter-option="filterOption"
                    v-model="form.users"
                  >
                    <a-select-option
                      v-for="user in availableUsers"
                      :key="user.id"
                      :value="user.id"
                      >{{ user.name }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>

                <a-button @click="onSubmit" class="btn btn-success float-right">
                  Save
                </a-button>
              </a-form-model>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Col, Row, Space } from 'ant-design-vue'
Vue.use(Space, Row, Col, Button)

import { UserService, ParticipantService } from '@/services/api'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 6 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 18 },
}

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      labelCol,
      wrapperCol,
      loading: true,
      allUsers: [],
      currentParticipant: {
        users: [],
        userDetails: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Please input Name',
            trigger: 'blur',
          },
        ],
        shortName: [
          {
            required: true,
            message: 'Please input Username (email address)',
            trigger: 'blur',
          },
        ],
        reportEmails: [
          {
            required: true,
            message: 'Please input emails for reports',
            trigger: 'blur',
          },
        ],
      },
      form: {
        name: '',
        reportEmails: '',
        shortName: '',
        collateral: 0,
        users: [],
        phone: null,
        addressLine1: null,
        addressLine2: null,
        zipCode: null,
        city: null,
        country: null,
        vatCode: null,
      },
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          var dataToSend = {
            name: this.form.name,
            reportEmails: this.form.reportEmails,
            shortName: this.form.shortName,
            collateral: this.form.collateral,
            users: this.form.users,
            phone: this.form.phone,
            addressLine1: this.form.addressLine1,
            addressLine2: this.form.addressLine2,
            zipCode: this.form.zipCode,
            city: this.form.city,
            country: this.form.country,
            vatCode: this.form.vatCode,
          }
          if (this.isEdit) {
            ParticipantService.update(this.$route.params.id, dataToSend).then(
              (response) => {
                this.$notification.success({
                  message: 'Participant update',
                  description: `Participant details have been updated successfully.`,
                })
                this.getData()
              }
            )
          } else {
            ParticipantService.save(dataToSend).then((response) => {
              // console.log(response.data.data)
              // this.dataSource = response.data.data
              this.$notification.success({
                message: 'Participant added',
                description: `Participant has been added successfully.`,
              })
              this.$router.push('/participants')
              // this.loading = false
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getData() {
      ParticipantService.get(this.$route.params.id).then((response) => {
        this.currentParticipant = response.data.data

        this.form.name = response.data.data.name
        this.form.reportEmails = response.data.data.reportEmails
        this.form.shortName = response.data.data.shortName

        this.form.collateral = response.data.data.collateral
        this.form.users = response.data.data.users || []

        this.form.phone = response.data.data.phone
        this.form.addressLine1 = response.data.data.addressLine1
        this.form.addressLine2 = response.data.data.addressLine2
        this.form.zipCode = response.data.data.zipCode
        this.form.city = response.data.data.city
        this.form.country = response.data.data.country
        this.form.vatCode = response.data.data.vatCode
        this.loading = false
      })
    },
    getUsers() {
      UserService.get().then((response) => {
        this.allUsers = response.data.data
      })
    },
  },
  watch: {
    isEdit: function (val) {
      if (!val) {
        this.form.name = ''
        this.form.reportEmails = ''
        this.form.shortName = ''
        this.form.collateral = 0
        this.form.users = []
        this.form.phone = null
        this.form.addressLine1 = null
        this.form.addressLine2 = null
        this.form.zipCode = null
        this.form.city = null
        this.form.country = null
        this.form.vatCode = null
      }
    },
  },
  computed: {
    availableUsers() {
      // Show unassigned users + users already assigned to this participant
      return this.allUsers.filter(
        (user) =>
          user.participant == null ||
          this.form.users.includes(user.id)
      )
    },
  },
  mounted() {
    this.getUsers()
    if (this.isEdit) {
      this.getData()
    } else {
      this.loading = false
    }
  },
}
</script>
